module.exports = __webpack_public_path__ + "static/media/nibsspay.d40d3479.svg";